export const articles = [
  {
    slug: 'how-to-submit-a-tip-safely',
    title: '爆料前必读：如何安全且有效地提交一条线索',
    excerpt:
      '同样一条线索，有人投出去石沉大海，有人三天就被跟进。差别往往不在事件本身，而在材料整理与投递方式。',
    category: '入门指引',
    author: '爆料网上编辑部',
    date: '2026-09-08',
    readTime: '8 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20illustration%20of%20a%20sealed%20envelope%20with%20a%20shield%20and%20a%20magnifying%20glass%2C%20cream%20and%20vermilion%20palette%2C%20soft%20natural%20light%2C%20clean%20flat%20paper%20texture%20background%2C%20calm%20professional%20mood%2C%20no%20text&width=1200&height=750&seq=baoliao-cover-submit&orientation=landscape',
    tags: ['投稿流程', '材料整理', '跟进技巧'],
    content: [
      {
        heading: '先把事件讲成一条时间线',
        paragraphs: [
          '大多数线索被搁置，是因为接收方需要在一堆零散信息里自己拼时间顺序。与其写一段情绪化的长文，不如先用三到五句话说清楚：什么时候、在哪里、发生了什么、涉及谁、目前进展到哪一步。',
          '把关键节点按日期排好，每一个节点后面标注你手上有什么材料可以对应。这份时间线本身就是最有说服力的东西，也让后续跟进的人愿意继续往下看。',
        ],
        list: [
          '发生时间与地点尽量精确到日期和具体场所',
          '按时间顺序列出关键节点，不要跳来跳去',
          '每个节点标注对应的证据类型，例如截图、录音、单据',
          '单独写清楚你希望解决的问题是什么',
        ],
      },
      {
        heading: '材料要能自证来源',
        paragraphs: [
          '截图会被质疑真伪，所以尽量保留原始载体：订单编号、支付流水、聊天记录的完整上下文，而不是只截一句最关键的话。完整的上下文往往看起来"不利"，但它恰恰是可信度的来源。',
          '如果是多人共同经历的问题，可以邀请对方各自单独提交一份，多份独立材料互相印证，比一个人写十页说明管用得多。',
        ],
        list: [
          '优先提供可核验的编号、单号与流水记录',
          '聊天记录保留完整对话，不掐头去尾',
          '涉及金额的写清具体数字与计算方式',
          '多人同类问题分开提交，形成交叉印证',
        ],
      },
      {
        heading: '投递后的正确跟进方式',
        paragraphs: [
          '投递之后不要在同一平台反复刷屏，也不要同时群发到十几个渠道后互相矛盾。选择两到三个匹配度最高的入口，记录下投递时间，间隔一周左右做一次礼貌的进度询问。',
          '如果事情有了新进展，用补充材料的方式追加，而不是重新发一条。这样接收方能清楚看到同一条线索的演变过程。',
        ],
        list: [],
      },
    ],
  },
  {
    slug: 'choose-the-right-channel',
    title: '找对渠道：不同类型的爆料该投给谁',
    excerpt:
      '消费纠纷投到财经板块，城市问题发进全国大厅，效果都会打折。渠道匹配度决定了你的线索被谁看到。',
    category: '渠道选择',
    author: '爆料网上编辑部',
    date: '2026-09-05',
    readTime: '6 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20illustration%20of%20an%20abstract%20map%20with%20connected%20location%20pins%20and%20flowing%20routing%20lines%2C%20cream%20amber%20and%20pine%20green%20palette%2C%20soft%20daylight%2C%20clean%20paper%20texture%20background%2C%20no%20text&width=1200&height=750&seq=baoliao-cover-channel&orientation=landscape',
    tags: ['渠道匹配', '平台分类', '投递策略'],
    content: [
      {
        heading: '先判断问题属于哪一类',
        paragraphs: [
          '把自己遇到的问题归到最贴近的一类：是个人消费合同纠纷，还是公共服务层面的问题，或者是行业性的普遍现象。分类影响的不只是投到哪个版块，也影响接收方评估这件事是否值得跟进。',
          '如果实在拿不准，可以用平台里的分类切换功能逐类浏览，看看同类事件通常出现在哪里，再决定投递方向。',
        ],
        list: [
          '个体消费纠纷优先投消费维权类入口',
          '公共设施与市政问题优先投城市本地类入口',
          '行业普遍现象适合投综合类与行业垂直类入口',
          '金融与投资相关问题务必选择带材料预审的渠道',
        ],
      },
      {
        heading: '垂直渠道与综合渠道怎么搭配',
        paragraphs: [
          '垂直渠道的读者更专业，讨论更深，但曝光面窄；综合渠道流量大，但信息容易被淹没。比较实用的做法是先投垂直渠道拿到相对专业的反馈，再把已经成型的表述同步到综合渠道。',
          '注意不要用同一条文案到处复制。稍微调整侧重点，让它更贴合对应渠道的读者关注点，被认真对待的概率会明显提高。',
        ],
        list: [],
      },
      {
        heading: '哪些内容不该投出去',
        paragraphs: [
          '涉及他人隐私的身份证号、家庭住址、未成年人的清晰照片与联系方式，都不应该在公开渠道传播。即便是你认为有过错的一方，公开其非必要个人信息也可能让整件事的性质发生变化。',
          '此外，未经核实的转述、来源不明的"内部消息"，建议先自行确认再决定是否提交。虚假线索一旦被查实，不仅浪费公共资源，也可能给你自己带来不必要的麻烦。',
        ],
        list: [
          '隐去与事件无关的个人身份信息',
          '未成年人相关材料做打码处理',
          '不做无偿的隐私扩散，只提交必要部分',
          '来源存疑的信息先标注"待核实"再提交',
        ],
      },
    ],
  },
  {
    slug: 'protect-your-privacy',
    title: '隐私自保指南：爆料时怎样降低暴露风险',
    excerpt:
      '很多人不是被对方找到的，而是被自己发出去的细节暴露的。这些容易被忽略的痕迹，最好提前处理。',
    category: '安全防护',
    author: '爆料网上编辑部',
    date: '2026-09-02',
    readTime: '7 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20illustration%20of%20a%20padlock%20with%20a%20fingerprint%20motif%20and%20layered%20paper%20shields%2C%20cream%20vermilion%20and%20pine%20green%20palette%2C%20soft%20light%2C%20clean%20flat%20background%2C%20no%20text&width=1200&height=750&seq=baoliao-cover-privacy&orientation=landscape',
    tags: ['隐私保护', '截图处理', '账号安全'],
    content: [
      {
        heading: '截图里最容易泄露的三类信息',
        paragraphs: [
          '第一类是界面自带信息：聊天软件顶部的备注名、头像、对话时间轴；第二类是内容里的数字：订单号、快递单号、手机号；第三类是图片本身的属性，比如原图的拍摄地点与时间。',
          '处理方式并不复杂，但需要养成习惯：截图后统一检查一遍，用色块覆盖敏感区域，而不是随手涂几笔。',
        ],
        list: [
          '遮盖头像、昵称、手机号与地址',
          '订单号保留前后各几位即可，中间打码',
          '不要直接发送相册里的原图，先做一次转存',
          '录音文件上传前，剪掉与事件无关的私人对话',
        ],
      },
      {
        heading: '账号与身份要分开',
        paragraphs: [
          '尽量使用与日常工作生活无关的账号来发布敏感内容，昵称不要包含真实姓名、生日或常用网名。同一个账号不要既发生活照又发敏感线索，两者很容易被关联起来。',
          '如果情况比较敏感，可以在提交前先和渠道确认是否支持匿名投递，并在正文里说明你希望隐去哪些信息。',
        ],
        list: [
          '注册独立账号，避免与真实社交账号互相关注',
          '昵称不使用生日、手机号片段等可推测信息',
          '不同平台的昵称不要完全一致',
          '提交时明确标注希望隐去的身份信息',
        ],
      },
      {
        heading: '线下沟通的注意事项',
        paragraphs: [
          '如果对方提出线下见面或要求提供更多私人材料，先确认对方身份与用途后再决定。任何要求你转账、缴纳"保证金"的所谓帮忙跟进，都应当直接拒绝。',
          '保留与渠道沟通的记录，一旦出现异常可以及时中止。安全永远排在传播效果之前。',
        ],
        list: [],
      },
    ],
  },
  {
    slug: 'identify-fake-tips',
    title: '学会甄别：三个方法判断一条爆料是否可信',
    excerpt:
      '刷到一条情绪拉满的爆料就转发，是很多人的习惯。动动手做这三步，能过滤掉大部分不实信息。',
    category: '事实核查',
    author: '爆料网上编辑部',
    date: '2026-08-29',
    readTime: '5 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20illustration%20of%20two%20contrasting%20document%20sheets%2C%20one%20clean%20and%20one%20torn%2C%20with%20a%20checkmark%20and%20a%20question%20mark%2C%20cream%20amber%20and%20vermilion%20palette%2C%20clean%20flat%20background%2C%20no%20text&width=1200&height=750&seq=baoliao-cover-verify&orientation=landscape',
    tags: ['事实核查', '信息来源', '传播习惯'],
    content: [
      {
        heading: '看有没有原始来源',
        paragraphs: [
          '可信度较高的一条信息，通常能追溯到最初的发布者或原始文件。如果整条内容都是"据网友说""有内部人士透露"，且找不到更早的出处，就需要保持谨慎。',
          '把关键句复制去搜一下，看看有没有更早、更完整的版本。很多时候你会发现，原版表达比转述的版本克制得多。',
        ],
        list: [
          '能否找到第一发布者或原始文件',
          '是否有具体的时间、地点与可核验的编号',
          '转述版本是否比原版更夸张',
        ],
      },
      {
        heading: '看信息是否完整而不是被裁剪',
        paragraphs: [
          '掐头去尾的截图是最常见的失真方式。一句原本带有前提条件的话，去掉前提之后就变成了完全相反的意思。遇到只给单张截图、不给完整上下文的内容，先存疑再判断。',
          '同样要警惕拼接式材料：把不同时间、不同事件的截图拼在一起，制造出并不存在的因果关系。',
        ],
        list: [],
      },
      {
        heading: '看传播者有没有利益动机',
        paragraphs: [
          '如果发布者在爆料的同时高价售卖"避坑课程""维权服务"，或者引导你加入付费群，就要多留一个心眼。真实的信息分享通常不需要先付费。',
          '理性的做法是：把爆料当作线索而不是结论，等更多独立来源出现后再形成自己的判断。',
        ],
        list: [
          '是否在借机推销产品或课程',
          '是否要求先付费才能看到"完整内容"',
          '是否有其他独立来源相互印证',
        ],
      },
    ],
  },
];